/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Row } from '../../Structure';
import Form from '../MainForm';
import InputText from '../InputText';
import SignatureCheckboxs from './SignatureCheckboxs';
import InputRadio from '../InputRadio';
import InputTitle from '../InputTitle';
import useDeclarationData from '../../../hooks/useDeclarationData';
import './DeclarationForm.scss';

const DeclarationForm = ({ EnableSpinner, SubmitSignatureForm }) => {
  const [values, setValues] = useState(useDeclarationData());
  const [employmentStatus, setEmploymentStatus] = useState(
    values.employmentStatus
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    values.employmentStatus = employmentStatus;

    EnableSpinner();
    SubmitSignatureForm({ ...values });
  };

  const handleOnRadioChange = (type) => {
    setEmploymentStatus(type);
  };

  const updateField = (event) => {
    const { name, value } = event;
    values[name] = value;
    setValues({ ...values });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        This form is only valid when section E is signed by:
        <li>
          The individuals employer where the individual has chosen the logbook
          route
        </li>
        <br />
        <p>
          <strong>Note:</strong> If you are Self Employed please complete this
          section as the "Individual&apos;s Employer".
          <br />
          <strong>Note:</strong> If renewing using a mixture of routes i.e.
          Logbook and On-site Assessment then Section E must be signed by the
          Individual&apos;s Employer.
        </p>
      </Row>
      <Row>
        <InputTitle>Is the applicant*:</InputTitle>
      </Row>
      <Row className="radio-button-group">
        <InputRadio
          onChange={handleOnRadioChange}
          value="employed"
          checked={employmentStatus === 'employed'}
        >
          Employed
        </InputRadio>
        <InputRadio
          onChange={handleOnRadioChange}
          value="self-employed"
          checked={employmentStatus === 'self-employed'}
        >
          Self-employed
        </InputRadio>
        <InputRadio
          onChange={handleOnRadioChange}
          value="unemployed"
          checked={employmentStatus === 'unemployed'}
        >
          Unemployed
        </InputRadio>
      </Row>
      <Row>
        <InputText
          labelTitle="Name of person completing application form"
          name="applicantName"
          onChange={updateField}
          placeholder="Type name of person completing application form here"
          value={values.applicantName}
        />
      </Row>
      <Row>
        <InputText
          labelTitle="Employer Name"
          name="testerName"
          onChange={updateField}
          placeholder="Type employer name here"
          value={values.testerName}
        />
      </Row>
      <Row>
        <InputText
          labelTitle="Company Name"
          name="centreName"
          onChange={updateField}
          placeholder="Type company name here"
          value={values.centreName}
        />
      </Row>
      <Row>
        <InputText
          labelTitle="Telephone Number"
          name="applicantPhoneNumber"
          onChange={updateField}
          placeholder="Type the telephone number here"
          type="tel"
          value={values.applicantPhoneNumber}
        />
      </Row>
      <Row>
        <InputText
          labelTitle="Email address"
          name="applicantEmail"
          onChange={updateField}
          placeholder="Type the email address here"
          type="email"
          value={values.applicantEmail}
        />
      </Row>
      <SignatureCheckboxs onChange={updateField} />
    </Form>
  );
};

DeclarationForm.propTypes = {
  EnableSpinner: PropTypes.func,
  SubmitSignatureForm: PropTypes.func,
};

DeclarationForm.defaultProps = {
  EnableSpinner: {},
  SubmitSignatureForm: {},
};

export default DeclarationForm;
